import { useTranslation } from 'react-i18next'
import { VpIcon } from '@vtmn-play/react'
import { VtmnTooltip } from '@vtmn/react'

const GmvForecastGapTitle = () => {
  const { t } = useTranslation()

  return (
    <div className="mg-weekly-gmv-gap-title">
      <div className="vp-caption" data-testid="text">
        {t('general.homepage.weekly-gmv-forecast-gap.title')}
      </div>

      <div className="mg-weekly-gmv-gap-title-tooltip">
        <VtmnTooltip
          position="top"
          tooltip={t('general.homepage.weekly-gmv-forecast-gap.tooltip')}
          data-testid="tooltip"
        >
          <VpIcon {...({ name: 'information', size: 20 } as any)} />
        </VtmnTooltip>
      </div>
    </div>
  )
}

export default GmvForecastGapTitle
